import { Reveal, StaggerGroup } from "@/components/Reveal";
import { SectionLabel } from "@/components/primitives";
import ServiceCard from "@/components/ServiceCard";
import { services } from "@/data/content";

export default function ServicesSection({ withHeader = true }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative border-t border-fs-border bg-fs-bg2 py-24 lg:py-32"
    >
      <div className="fs-shell">
        {withHeader && (
          <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
            <div className="lg:col-span-7">
              <Reveal>
                <SectionLabel testId="services-label">Services</SectionLabel>
              </Reveal>
              <Reveal delay={0.1}>
                <h2 className="mt-6 fs-h2">
                  End-to-end solutions for
                  <br className="hidden sm:block" /> modern service businesses.
                </h2>
              </Reveal>
            </div>
            <div className="lg:col-span-5">
              <Reveal delay={0.15}>
                <p className="fs-body">
                  We combine strategy, design, automation, and operational systems
                  to build a connected growth engine around the business.
                </p>
              </Reveal>
            </div>
          </div>
        )}

        <StaggerGroup className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <ServiceCard key={s.slug} service={s} index={i} />
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
